import "core-js/modules/es.array.reduce.js";
import { __assign, __spreadArrays } from "tslib";
import { useEffect, useState, useContext } from "react";
import createUseContext from "constate";
import { useDCContext } from "@kyma-project/documentation-component";
import { createElementClass } from "../../../helpers";
import { scrollSpy } from "../scrollSpy";
var tocClassName = "toc";

function chooseSources(sourcesFromContext, sourcesFromArg) {
  var srcs = sourcesFromArg;

  if (!srcs || !srcs.length) {
    srcs = sourcesFromContext;
  }

  if (!srcs || !srcs.length) {
    return [];
  }

  if (srcs.length === 1) {
    if (Array.isArray(srcs[0])) {
      srcs = srcs[0];
    } else {
      srcs = [srcs[0]];
    }
  }

  return srcs;
}

function flatHeaders(headers) {
  if (!headers) {
    return [];
  }

  var children = [];

  for (var _i = 0, headers_1 = headers; _i < headers_1.length; _i++) {
    var header = headers_1[_i];
    children = __spreadArrays(children, flatHeaders(header.children));
  }

  return __spreadArrays(headers, children);
}

function extractHeaders(sources) {
  return sources.map(function (source) {
    if (source.data) {
      return source.data.headers;
    }

    return [];
  }).reduce(function (a, b) {
    return a.concat(b);
  }, []);
}

var HeadersProvider = function HeadersProvider(_a) {
  var sources = _a.sources,
      _b = _a.sourceTypes,
      sourceTypes = _b === void 0 ? ["markdown", "md"] : _b,
      _c = _a.selector,
      selector = _c === void 0 ? "." + createElementClass(tocClassName + "-wrapper") + " li > a" : _c,
      _d = _a.offset,
      offset = _d === void 0 ? 10 : _d,
      _e = _a.cachingHeadings,
      cachingHeadings = _e === void 0 ? true : _e,
      _f = _a.enableSmoothScroll,
      enableSmoothScroll = _f === void 0 ? false : _f,
      pushStateBehavior = _a.pushStateBehavior,
      postProcessing = _a.postProcessing,
      _callback = _a.callback;
  var emptyAnchors = {
    "1": "",
    "2": "",
    "3": "",
    "4": "",
    "5": "",
    "6": ""
  };

  var _g = useState(emptyAnchors),
      activeAnchors = _g[0],
      setActiveAnchors = _g[1];

  var _h = useState(""),
      activeAnchor = _h[0],
      setActiveAnchor = _h[1];

  useEffect(function () {
    var args = {
      selector: selector,
      offset: offset,
      cachingHeadings: cachingHeadings,
      enableSmoothScroll: enableSmoothScroll,
      pushStateBehavior: pushStateBehavior,
      callback: function callback(element) {
        _callback && _callback(element);
        var hash = element.hash.slice(1);
        setActiveAnchor(hash);
      }
    };
    var removeListeners = scrollSpy(args);
    return function () {
      removeListeners();
    };
  }, []);
  useEffect(function () {
    setActiveAnchors(emptyAnchors);
    setAnchors(flattenHeaders);
  }, [activeAnchor]);

  var setActiveParent = function setActiveParent(header) {
    setActiveAnchors(function (anchors) {
      var _a;

      return __assign(__assign({}, anchors), (_a = {}, _a[header.level] = header.id, _a));
    });

    if (header.parent) {
      setActiveParent(header.parent);
    }
  };

  var setAnchors = function setAnchors(h) {
    for (var _i = 0, h_1 = h; _i < h_1.length; _i++) {
      var header = h_1[_i];

      if (activeAnchor === header.id) {
        setActiveParent(header);
      }
    }
  };

  var getActiveAnchors = function getActiveAnchors() {
    return activeAnchors;
  };

  var pureSources = useDCContext().pureSources;
  var arrOfSources = chooseSources(pureSources, sources);
  var filteredSources = arrOfSources.filter(function (source) {
    return sourceTypes.includes(source.type);
  });

  if (!filteredSources || !filteredSources.length) {
    return;
  }

  var headers = extractHeaders(filteredSources);

  if (postProcessing) {
    headers = postProcessing(filteredSources, headers);
  }

  var flattenHeaders = flatHeaders(headers);
  return {
    getActiveAnchors: getActiveAnchors,
    headers: headers,
    className: tocClassName
  };
};

var _a = createUseContext(HeadersProvider),
    Provider = _a.Provider,
    Context = _a.Context;

function useHeadersContext() {
  return useContext(Context);
}

export { Provider as HeadersProvider, Context as HeadersContext, useHeadersContext };